import { uid } from "@dhx/ts-common/core";
import { sv } from "@dhx/ts-common/dom";

const figureWidth = 10;
const forms = {
	circle(color: string, fill: string, fillOpacity: number) {
		return sv("circle", {
			id: uid(),
			r: figureWidth / 2,
			fill,
			class: `figure ${color !== "none" ? "with-stroke" : ""}`,
			"stroke-width": 2,
			"fill-opacity": fillOpacity,
			stroke: color,
			transform: `translate(0, -1)`,
		});
	},
	rect(color: string, fill: string, fillOpacity: number) {
		return sv("rect", {
			id: uid(),
			fill,
			"fill-opacity": fillOpacity,
			width: figureWidth,
			"stroke-width": 2,
			height: figureWidth,
			class: `figure ${color !== "none" ? "with-stroke" : ""}`,
			stroke: color,
			transform: `translate(${-figureWidth / 2}, ${-figureWidth / 2})`,
		});
	},
};

export function legendShape(form, item) {
	if (typeof form === "string") {
		form = forms[form];
	}
	return form(item.color || "none", item.fill, item.alpha || 1);
}
